import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, Button, Grid, Label, Flex, Modal, ErrorMsg } from "atoms";
import { FormInput, FormSelect } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "molecules/Modals";
import { usePropsoch } from "contexts/Propsoch";
import api from "utils/api";

export const AddNewInfrastructureModal = ({
  isOpen,
  onClose,
  title,
  isLocation,
  preRecord,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  const {
    state: { locations },
    actions: { getLocation },
  } = usePropsoch();

  const [locationLoading, setLocationLoading] = useState(false);
  const loadRoles = useCallback(() => {
    if (isLocation) {
      setLocationLoading((prev) => true);
      getLocation()
        ?.then(() => {})
        .finally(() => {
          setLocationLoading(false);
        });
    }
  }, [getLocation, isLocation]);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  const [types, setTypes] = useState([]);
  const [typesLoading, setTypesLoading] = useState(false);
  const loadTypes = useCallback(async () => {
    setTypesLoading(true);
    try {
      const { data } = await api("/nearbyinfras/get", {
        method: "get",
      });

      setTypes(data?.data);
      setTypesLoading(false);
    } catch (e) {
      console.error(e);
      setTypesLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTypes();
  }, [loadTypes]);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "48.8rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preRecord ? "Edit" : "Add New"} {title || ""}
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                name: preRecord?.name || "",
                nearbyInfraId: preRecord?.nearbyInfraId || "",
                ...(isLocation
                  ? { locationId: preRecord?.locationId || "" }
                  : {}),
              }}
              onSubmit={onSubmit}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                nearbyInfraId: Yup.string().required("Type is required"),
                ...(isLocation
                  ? {
                      locationId: Yup.string().required("Location is required"),
                    }
                  : {}),
              })}
            >
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Name" req />
                        <FormInput
                          name="name"
                          placeholder="Enter Name"
                          req
                          onChange={(e) => {
                            setFieldValue("name", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>
                      <Grid gridRowGap="1.6rem">
                        <Label text="Type" req />
                        <FormSelect
                          name="nearbyInfraId"
                          placeholder="Enter Type"
                          req
                          onChange={(e) => {
                            // setFieldValue("role", e?.target?.value);
                            error && resetError();
                          }}
                          isLoading={typesLoading}
                          options={types?.map((type) => ({
                            label: type?.name,
                            value: type?.id,
                          }))}
                        />
                      </Grid>
                      {isLocation && (
                        <Grid gridRowGap="1.6rem">
                          <Label text="Location" req />
                          <FormSelect
                            name="locationId"
                            placeholder="Enter Location"
                            req
                            onChange={(e) => {
                              // setFieldValue("role", e?.target?.value);
                              error && resetError();
                            }}
                            isLoading={locationLoading}
                            options={locations?.map((role) => ({
                              label: role?.name,
                              value: role?.id,
                            }))}
                          />
                        </Grid>
                      )}
                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
